import React, { useEffect } from "react";
import { CheckCircle, XCircle, X } from "lucide-react";

const ModernPopup = ({
  isOpen,
  onClose,
  message,
  isError,
  unmatchedItems = [],
  matchedItems = [],
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className={`popup-container ${isError ? "error" : "success"}`}>
        <button className="popup-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="popup-icon">
          {isError ? (
            <XCircle className="icon" size={48} />
          ) : (
            <CheckCircle className="icon success-icon" size={48} />
          )}
        </div>

        <h3 className="popup-title">{isError ? "Error" : "Success!"}</h3>

        <p className="popup-message">{message}</p>

        {(unmatchedItems.length > 0 || matchedItems.length > 0) && (
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              width: "100%",
              justifyContent: "center",
            }}>
            {/* Unmatched Items */}
            {unmatchedItems.length > 0 && (
              <div
                style={{
                  width: "48%",
                  maxHeight: "150px",
                  overflowY: "auto",
                  overflowX: "auto",
                  background: "#f8f8f8",
                  textAlign: "left",
                  marginBlock: "2px",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                }}>
                <h5 style={{ fontSize: "13px", marginBottom: "8px" }}>
                  Unmatched Items ({unmatchedItems?.length})
                </h5>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {unmatchedItems?.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        fontSize: "14px",
                        color: "red",
                        margin: "4px 0",
                      }}>
                      <div
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          direction: "ltr",
                          textAlign: "left",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={item}>
                        • {item}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Matched Items */}
            {matchedItems?.length > 0 && (
              <div
                style={{
                  width: "48%",
                  maxHeight: "150px",
                  overflowY: "auto",
                  background: "#f8f8f8",
                  textAlign: "left",
                  marginBlock: "2px",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                }}>
                <h5 style={{ fontSize: "13px", marginBottom: "8px" }}>
                  Matched Items ({matchedItems.length})
                </h5>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {matchedItems?.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        fontSize: "14px",
                        color: "green",
                        margin: "4px 0",
                      }}>
                      <div
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          direction: "ltr",
                          textAlign: "left",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={item?.label || item?.item_code}>
                        • {item?.label || item?.item_code}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        <button
          className={`popup-button ${
            isError ? "error-button" : "success-button"
          }`}
          onClick={onClose}>
          {isError ? "Ok" : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default ModernPopup;
